// TODO use/update models
import { CrudState } from "@/store/modules/crud/State";
import ICatalog from "@/models/ICatalog";
import IStand from "@/models/IStand";

export class State extends CrudState {
  dataList: Array<IStand> = [];
  dataItem: IStand | null = null;
}
